module.exports = __webpack_public_path__ + "static/media/ProcessFlowDAP.c3c9c086.png";